import styled from "styled-components";

export const ProductRowContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 8px;
  justify-items: center;
  align-items: start;
  border-radius: 18px;

  @media (max-width: 1600px) {
    grid-template-columns: repeat(4, 1fr);
  }
    @media (max-width: 1440px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 800px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 500px) {
    grid-template-columns: 1fr;
  }
`;
